import React, { FC } from 'react'
import { Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { ReactComponent as ArrowImg } from '../../../images/footer/arrow-up.svg'
import { NavigationDashboardBottom } from '../Navigation'
import { Version } from '../../Version'

const useStyles = makeStyles((theme: Theme) => ({
  footer: {
    display: 'flex',
    width: '100%',
    // height: 112,
    padding: '0 32px',
    position: 'relative',
    zIndex: 1000,
    background: theme.palette.info.main,
  },
  container: {
    justifyContent: 'space-between',
    maxWidth: 1376,
    margin: '0 auto',
    color: `rgba(255, 255, 255, 0.64)`,
    borderTop: '1px solid rgba(255,255,255,0.32)',
  },
  leftSide: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: theme.palette.primary.light,
    opacity: '0.64',
  },
  descTxt: {
    fontSize: 14,
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    '& :last-child': {
      fontSize: 14,
    },
  },
  rightSide: {
    display: 'flex',
    alignItems: 'center',
  },
  dev: {
    paddingRight: 32,
    fontSize: 12,
    textAlign: 'right',
  },
  devLink: {
    textDecoration: 'none',
    color: theme.palette.secondary.light,
  },
  footerArrow: {
    cursor: 'pointer',
    width: 24,
  },
}))

export const FooterDashboard: FC = () => {
  const classes = useStyles()
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
  return (
    <footer className={classes.footer}>
      <Grid container className={classes.container}>
        <Grid item className={classes.leftSide}>
          <NavigationDashboardBottom />

          <Typography variant="body1">
            © Copyright {new Date().getFullYear()} | Guildwell | All Rights Reserved
          </Typography>
        </Grid>

        <Grid item className={classes.rightSide}>
          <Typography variant="body1" className={classes.dev}>
            Design and development{' '}
            <a href="https://rightandabove.com/" target={'_blank'} rel="noreferrer" className={classes.devLink}>
              Right&Above
            </a>
          </Typography>
          <ArrowImg onClick={handleClick} className={classes.footerArrow} />
        </Grid>
      </Grid>
      <Version />
    </footer>
  )
}
